import { useEffect } from 'react'
import { apiCall } from '../config/api'
import { SortField } from '../interfaces/DataGrid/DataGridSettings'
import { Filter } from '../interfaces'

export interface DataGridElements<T> {
  items: T[]
  pageIndex: number
  pageSize: number
  totalItems: number
  totalPages: number
}

export function useFetchDataGrid<Type, DataGridType>(
  resource: string,
  page: number,
  rowsPerPage: number,
  filters: Filter[],
  dispatcher: any,
  funcToMap?: (items: Type[]) => DataGridType[],
  sorters?: SortField[]
): void {
  const uri: string = `${resource}?pageIndex=${page}&pageSize=${rowsPerPage}`
  const arrFilters: string[] = filters.map(
    ({ key, value }) => `${key}=${value}`
  )
  const arrSorters: string[] = sorters
    ? sorters.map((sorter) => `sorters=${JSON.stringify(sorter)}`)
    : []
  const strFilters: string =
    arrFilters.length > 0 ? `&${arrFilters.join('&')}` : ''
  const strSorters: string =
    arrSorters.length > 0 ? `&${arrSorters.join('&')}` : ''

  const finalUri: string = uri + strFilters + strSorters

  useEffect(() => {
    dispatcher({ type: 'SET_IS_LOADING', payload: true })
    dispatcher({ type: 'SET_GRID_STATUS', payload: 'cargando' })
    apiCall('GET', finalUri)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error(`No fue posible obtener los registros.`)
        }
        return response.data
      })
      .then(({ items, totalItems }: DataGridElements<Type>) => {
        if (items.length === 0) {
          dispatcher({ type: 'CHANGE_PAGE', payload: 0 })
        }
        dispatcher({ type: 'SET_IS_LOADING', payload: false })
        dispatcher({ type: 'SET_TOTAL_ITEMS', payload: totalItems })
        dispatcher({ type: 'SET_GRID_STATUS', payload: 'terminado' })
        dispatcher({
          type: 'SET_ROWS',
          payload: items
        })
        if (funcToMap !== undefined) {
          funcToMap(items)
        }
      })
      .catch((error) => {
        dispatcher({ type: 'SET_IS_LOADING', payload: false })
        dispatcher({ type: 'SET_GRID_STATUS', payload: 'error' })
        dispatcher({ type: 'SET_GRID_ERROR', payload: error })
        dispatcher({ type: 'CHANGE_PAGE', payload: 0 })
      })
  }, [page, rowsPerPage, filters, sorters])
}
